/*
 * Store locator filter.
 * Matches the typed text against each card's city and address, which Liquid
 * has already flattened into a data attribute. No network, no fuzzy matching —
 * with a handful of shops a substring test is the whole requirement, and the
 * full list is in the HTML if this script never runs.
 */
(function () {
  function setup() {
    var input = document.querySelector('[data-nv-loc-search]');
    var list = document.querySelector('[data-nv-loc-list]');
    if (!input || !list || list.dataset.nvLocReady) return;
    list.dataset.nvLocReady = '1';

    var cards = Array.prototype.slice.call(list.querySelectorAll('[data-nv-loc-item]'));
    var empty = document.querySelector('[data-nv-loc-empty]');

    function filter() {
      var q = input.value.trim().toLowerCase();
      var shown = 0;

      cards.forEach(function (card) {
        var match = !q || card.dataset.nvLocItem.indexOf(q) !== -1;
        card.hidden = !match;
        if (match) shown++;
      });

      if (empty) empty.hidden = shown !== 0;
    }

    input.addEventListener('input', filter);

    // A search field offers to clear itself; that fires 'search', not 'input',
    // in Safari.
    input.addEventListener('search', filter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);
})();
